<template>
  <div class="container">
    <div class="main" >
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">合作意向</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>合作意向</h2>
            <div class="notice-box" v-show="ifHoliday()">
                <div class="notice-yellow">
                    {{holidayWord()}}
                </div>
            </div>
            <div>
                <div class="weui-cells__title" >点击选择合作行业</div>
                <div class="weui-cells " >
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">合作行业</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.type">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1603441323">提货安装</option>
                                <option value="1603441334">修墙 / 补洞 / 隔断</option>
                                <option value="1603441347">装修Gyprock</option>
                                <option value="1603441357">油漆</option>
                                <option value="1603441367">除草 / 花园维护</option>
                                <option value="1603441377">日常水电维修 / 水管工 / 电工</option>
                                <option value="1603441388">饭店抽油池服务（Grease Trap Service）</option>
                                <option value="1603441400">手机 / 电子产品维修</option>
                                <option value="1603441414">小家电 / 大家电维修</option>
                                <option value="1603441424">洗车 / 汽车贴膜汽车维修保养</option>
                                <option value="1603441435">旧家电回收</option>
                                <option value="1603441445">旧家具回收</option>
                                <option value="1603441457">衣物干洗</option>
                                <option value="1603441468">清洁 / 消毒 / 垃圾处理 </option>
                                <option value="1603441477">按摩修脚</option>
                                <option value="1603441491">开锁换锁</option>
                                <option value="1603441504">月嫂 / 保姆</option>
                                <option value="1603441516">搬运</option>
                                <option value="1603441525">其他生活服务</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell" v-if="data.type==1||data.type==2">
                        <div class="weui-cell__bd">
                            <p>团队人数</p>
                        </div>
                        <div class="weui-cell__ft">
                        <v-counter :num='data.team_num' @plus="plusTeam()" @minus="minusTeam()"></v-counter>
                        </div>
                    </div>
                    <div class="weui-cell" v-if="data.type==1||data.type==2">
                        <div class="weui-cell__bd">
                            <p>车辆数量</p>
                        </div>
                        <div class="weui-cell__ft">
                        <v-counter  :num='data.vehicle_num' @plus="plusVehicle()" @minus="minusVehicle()"></v-counter>
                        </div>
                    </div>
                    <div class="weui-cell" v-if="data.type==1||data.type==2">
                        <div class="weui-cell__bd">
                            <p>行业经验（年）</p>
                        </div>
                        <div class="weui-cell__ft">
                        <v-counter  :num='data.experience'  @plus="plusExp()" @minus="minusExp()"></v-counter>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title" v-show="data.type">联系信息</div>
                <div class="weui-cells weui-cells_form" v-show="data.type">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">公司名称</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请填写贵公司名称" v-model="data.company"> 
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请填写联系人称呼" v-model="data.name"> 
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">联系手机</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="tel" placeholder="请填写联系人手机号" v-model="data.phone">
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">微信号</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="（选填）" v-model="data.wechat">
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">电子邮箱</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="（选填）" v-model="data.mail">
                        </div>
                    </div>

                </div>


                <div class="weui-cells__title">详情描述</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" placeholder="请简单介绍您期望的合作详情" rows="3" v-model="data.content"></textarea>
                        </div>
                    </div>
                </div>
            <br>
            </div>
        </div>
        <div class="btn-box-fix">
            <div class="btn-container">
                <div class="btn active" @click="submitOrder()">提交表单</div>
            </div>
        </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <div v-show="postSuccess">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">提交成功</strong></div>
            <div class="weui-dialog__bd">感谢您的提交，希望我们可以顺利达成合作！我们将尽快与您联系</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="goto('/')">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在提交</p>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';

export default {
  name: 'index',
  data () {
    return {
        data:{
            team_num:5,
            name:"",
            phone:"",
            wechat:"",
            mail:"",
            vehicle_num:3,
            experience:2,
            type:0,
            content:"",
        },
        isSending:false,
        localError:[],
        localErrorShow:false,
        postSuccess:false
    }
  },
  methods: {
    plusTeam: function (type) {
        this.data.team_num = this.data.team_num+1;
		if(this.data.team_num>50){
			this.data.team_num=50;
        }
	},
    minusTeam: function (type) {
        this.data.team_num = this.data.team_num-1;
		if(this.data.team_num<1){
			this.data.team_num=1;
		}
    },
    plusVehicle: function (type) {
        this.data.vehicle_num = this.data.vehicle_num+1;
		if(this.data.vehicle_num>50){
			this.data.vehicle_num=50;
        }
	},
    minusVehicle: function (type) {
        this.data.vehicle_num = this.data.vehicle_num-1;
		if(this.data.vehicle_num<0){
			this.data.vehicle_num=0;
		}
    },
    plusExp: function (type) {
        this.data.experience = this.data.experience+1;
		if(this.data.experience>20){
			this.data.experience=20;
        }
	},
    minusExp: function (type) {
        this.data.experience = this.data.experience-1;
		if(this.data.experience<1){
			this.data.experience=1;
		}
    },
    goBack: function() {
        this.$router.push('/service/joinus');
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    submitOrder: function() {
        if(!this.checkSubmit()){
            return false;
        }
        else{
            this.submitOrderPost();
        }

    },
    checkSubmit(){
        this.localError = [];
        if (!this.data.type) {
            this.localError.push("请选择合作类型");
        }
        if (!this.data.company) {
            this.localError.push("请填写公司名称");
        }
        if (!this.data.name) {
            this.localError.push("请填写联系人称呼");
        }
        if (this.data.phone.length<8 || this.data.phone.length>11) {
            this.localError.push("手机号码长度不正确，请检查是否正确");
        }

        if (!this.data.content) {
            this.localError.push("请填写合作的详情介绍");
        }
        
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    submitOrderPost(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.data));
        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Join/add', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.isSending = false;
            that.postSuccess = true;
          }
          else{
            alert("提交失败："+response.data.data);
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-joinus-bg");
    if(this.data.username==""&&localStorage.member_name){
        this.data.username = localStorage.member_name;
    }
    if(this.data.userphone==""&&localStorage.member_phone){
        this.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-joinus-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:60px;
}

.container /deep/ .weui-label{
    width:90px;
}

.container /deep/ .weui-cell__ft .qty span{
    font-size:1em;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 0 14px;
    text-align:center;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}


</style>



// WEBPACK FOOTER //
// src/pages/service/form/joinus.vue